import { environment } from "../environments/environment";
import { addSpotlightProduct, getUserAvailability, getUsersOfInvestor } from "../Service/user";

const baseUrl = environment.baseUrl;
const API = Object.freeze({
	getUser: `${baseUrl}/users/getUser`,
	getUserByPhoneNumber: `${baseUrl}/users/getUserByPhoneNumber`,
	getUserByEmail: `${baseUrl}/users/getUserByEmail`,
	getRawUsers: `${baseUrl}/users/getRawUsers`,
	getRawUserById: `${baseUrl}/users/getRawUserById`,
	sendWelcomeEmail: `${baseUrl}/users/send-welcome-email`,
	checkUsernameAvailability: `${baseUrl}/users/check-username`,
	getUserAvailability: `${baseUrl}/users/getUserAvailability`,
	getMeetingsAvailability: `${baseUrl}/meetings/getAvailability`,
	updateMeetingsAvailability: `${baseUrl}/meetings/updateAvailability`,
	postUser: `${baseUrl}/users/createUser`,
	getPostById: `${baseUrl}/api/posts/get_post_by_id`,
	getAllPayments: `${baseUrl}/payment/getAllPayments`,
	postStartUpData: `${baseUrl}/startup/createStartup`,
	getUsersOfStartup :`${baseUrl}/startup/getUsersOfStartup`,
	updateStartUpData: `${baseUrl}/startup/updateStartUp`,
	updateInvestorData: `${baseUrl}/investor/updateInvestor`,
	updateVcData: `${baseUrl}/vc/updateVc`,
	deleteStartUp: `${baseUrl}/startup/delete_startup`,
	loginUser: `${baseUrl}/users/login`,
	blockuser: `${baseUrl}/users/blockuser`,
	getUserByIdBody: `${baseUrl}/users/getUserByIdBody`,
	unblockUser: `${baseUrl}/users/unblockuser`,
	linkdinLogin: `${baseUrl}/users/linkdin_login`,
	getLinkedInProfile: `${baseUrl}/users/getLinkedInProfile`,
	postUserPost: `${baseUrl}/api/posts/newPost`,
	sharePostOnLinkedin: `${baseUrl}/api/posts/shareOnLinkedin`,
	uploadDocument: `${baseUrl}/upload`,
	getDocument: `${baseUrl}/documentation/getDocumentsByUser`,
	getAllPosts: `${baseUrl}/api/posts/getposts`,
	getRecommendedPosts: `${baseUrl}/api/posts/getRecommendedPosts`,
	getAllPublicPosts: `${baseUrl}/api/posts/getPublicPosts`,
	getAllCommunityPosts: `${baseUrl}/api/posts/getCommunityPosts`,
	getAllCommunityAdminPosts: `${baseUrl}/api/posts/getCommunityAdminPosts`,
	updateUser: `${baseUrl}/users/updateFounder`,
	getOnePager: `${baseUrl}/startUp/getOnePager`,
	getUserById: `${baseUrl}/users/getUserById`,
	getStartupByFounderId: `${baseUrl}/startup/getStartupByFounderId`,
	getStartUpById: `${baseUrl}/startup/getStartupById`,
	updateUserById: `${baseUrl}/users/updateUserById`,
	updateIntroMessage: `${baseUrl}/startup/introMessage`,
	getSavedPosts: `${baseUrl}/api/posts/savedPosts`,
	postResetPaswordLink: `${baseUrl}/users/requestPasswordReset`,
	postNewPassword: `${baseUrl}/users/resetPassword`,
	investNow: `${baseUrl}/startUp/investNow`,
	changePassword: `${baseUrl}/users/changePassword`,
	likeUnlikePost: `${baseUrl}/api/posts/likeUnlikePost`,
	pendingConnectionRequests: `${baseUrl}/connections/getPendingConnectionRequests`,
	sentConnectionRequests: `${baseUrl}/connections/getSentPendingConnectionRequests`,
	acceptConnectionRequest: `${baseUrl}/connections/acceptConnectionRequest`,
	rejectConnectionRequest: `${baseUrl}/connections/rejectConnectionRequest`,
	getRecommendations: `${baseUrl}/connections/getRecommendations`,
	getSavedPostCollections: `${baseUrl}/api/posts/getSavedPostCollections`,
	getSavedPostsByCollection: `${baseUrl}/api/posts/getSavedPostsByCollection`,
	getUserConnections: `${baseUrl}/connections/getUserConnections`,
	sendConnectionRequest: `${baseUrl}/connections/sendConnectionRequest`,
	getConnectionStatus: `${baseUrl}/connections/check-status`,
	sendPostComment: `${baseUrl}/api/posts/comment`,
	getPostComment: `${baseUrl}/api/posts/getComments`,
	cancelConnectionRequest: `${baseUrl}/connections/cancelConnectionRequest`,
	getSearchResults: `${baseUrl}/users/search`,
	savePostByUserId: `${baseUrl}/api/posts/savePost`,
	deletePost: `${baseUrl}/api/posts/deletePost`,
	getUserChats: `${baseUrl}/chat/getUserChats`,
	createChat: `${baseUrl}/chat/createChat`,
	addMessage: `${baseUrl}/message/addMessage`,
	getSinglePost: `${baseUrl}/api/posts/getSinglePost`,
	findChat: `${baseUrl}/chat/findChat`,
	markMessagesAsRead: `${baseUrl}/message/markMessagesAsRead`,
	getUnreadMessageCount: `${baseUrl}/message/getUnreadMessageCount`,
	getTotalUnreadMessagesCount: `${baseUrl}/message/getAllUnreadMessageCount`,
	getUserByUserName: `${baseUrl}/users/getUserByUserName`,
	togglePinMessage: `${baseUrl}/chat/togglePin`,
	getPinnedChat: `${baseUrl}/chat/getPinnedChat`,
	getInvestorById: `${baseUrl}/investor/getInvestorById`,
	postInvestorData: `${baseUrl}/investor/createInvestor`,
	addStartupInvested: `${baseUrl}/investor/addStartupInvested`,
	addSectorOfInterest: `${baseUrl}/investor/addSectorOfInterest`,
	uploadLogo: `${baseUrl}/investor/uploadLogo`,
	getMessageByChatId: `${baseUrl}/message/getMessages`,
	clearChat: `${baseUrl}/message/clearChat`,
	createCommunity: `${baseUrl}/community/createCommunity`,
	getAllCommunity: `${baseUrl}/community/getAllCommunitiesByUserId`,
	addMyInterest: `${baseUrl}/investor/addMyInterest`,
	getFeaturedPostsByUser: `${baseUrl}/api/posts/getFeaturedPostsByUser`,
	getCompanyUpdatePosts: `${baseUrl}/api/posts/getCompanyUpdatePosts`,
	addToFeaturedPost: `${baseUrl}/api/posts/addToFeaturedPost`,
	addToCompanyUpdate: `${baseUrl}/api/posts/addToCompanyUpdatePost`,
	getCommunityById: `${baseUrl}/community/getCommunityById`,
	getNewCommunityById: `${baseUrl}/communities/getCommunityById`,
	getAllCommunitiesByUserId: `${baseUrl}/communities/getAllCommunitiesByUserId`,
	joinCommunity: `${baseUrl}/communities/addMembersToCommunity`,
	getChatSettings: `${baseUrl}/chat/getChatSettings`,
	getCommunitySettings: `${baseUrl}/community/getCommunitySettings`,
	sendCommunityUpdate: `${baseUrl}/communities/sendUpdate`,
	deleteComment: `${baseUrl}/api/posts/deleteComment`,
	likeComment: `${baseUrl}/api/posts/toggleLikeComment`,
	unsavePost: `${baseUrl}/api/posts/unsavePost`,
	removeFromFeaturedPost: `${baseUrl}/api/posts/removeFromFeaturedPost`,
	removeCompanyUpdatePost: `${baseUrl}/api/posts/removeCompanyUpdatePost`,
	getUserPost: `${baseUrl}/api/posts/user_post`,
	deleteMessage: `${baseUrl}/message/deleteMessage`,
	getNotifications: `${baseUrl}/notification/getNotification`,
	markNotificationAsRead: `${baseUrl}/notification/markMessageAsRead`,
	markAllNotificationAsRead: `${baseUrl}/notification/markAllNotificationsAsRead`,
	getLikeCount: `${baseUrl}/api/posts/likeCount`,
	searchStartUps: `${baseUrl}/startup/searchStartUps`,
	addStartUpToUser: `${baseUrl}/users/addStartUpToUser`,
	deleteDocument: `${baseUrl}/documentation/deleteDocument`,
	markMessagesAsReadInCommunities: `${baseUrl}/message/markMessagesAsReadInCommunities`,
	getUnreadMessageCountInCommunities: `${baseUrl}/message/getUnreadMessageCountInCommunities`,
	getExploreFilters: `${baseUrl}/users/exploreFilters`,
	getExploreFilteredData: `${baseUrl}/users/explore`,
	getExploreInvestorIds: `${baseUrl}/users/exploreInvestorIds`,
	getExploreVcIds: `${baseUrl}/users/exploreVcIds`,
	searchInvestors: `${baseUrl}/investor/searchInvestors`,
	addUserAsInvestor: `${baseUrl}/users/addUserAsInvestor`,
	updateCommunity: `${baseUrl}/community/updateCommunity`,
	getUnAddedMembers: `${baseUrl}/community/getUnAddedMembers`,
	addMembersToCommunity: `${baseUrl}/community/addMembersToCommunity`,
	createSecretKey: `${baseUrl}/users/createSecretKey`,
	validateSecretKey: `${baseUrl}/users/validateSecretKey`,
	getInvestorFromOneLink: `${baseUrl}/investor/getOnePager`,
	createMeeting: `${baseUrl}/schedule/createMeeting`,
	createMeetingLink: `${baseUrl}/schedule/createMeetingLink`,
	validateMeetingAuth: `${baseUrl}/schedule/validateMeetingAuth`,
	getAllMeetings: `${baseUrl}/schedule/getAllMeetings`,
	deleteMeeting: `${baseUrl}/schedule/deleteMeeting`,
	removeConnection: `${baseUrl}/connections/removeConnection`,
	requestMeeting: `${baseUrl}/schedule/requestBookingSlot`,
	getAllMeetingRequests: `${baseUrl}/schedule/getAllRequests`,
	acceptMeetingRequest: `${baseUrl}/schedule/acceptMeetingRequest`,
	getNotificationCount: `${baseUrl}/notification/getNotificationCount`,
	deleteCommunity: `${baseUrl}/community/deleteCommunity`,
	exitCommunity: `${baseUrl}/community/exitCommunity`,
	getfolders: `${baseUrl}/documentation/getFolderByUser`,
	getAllMileStone: `${baseUrl}/startup/getAllMileStone`,
	getUserMilestones: `${baseUrl}/startup/getUserMilestones`,
	addMilestoneToUser: `${baseUrl}/startup/addMilestoneToUser`,
	deleteUserMilestone: `${baseUrl}/startup/deleteUserMilestone`,


	// Readiness APIs
	getReadinessQuestions: `${baseUrl}/startup/readiness/questions`,
	updateReadinessAnswers: `${baseUrl}/startup/readiness`,
	getReadinessStatus: `${baseUrl}/startup/readiness`,

	//traction APIs
	updateTractionData: `${baseUrl}/startup/traction`,
	getTractionData: `${baseUrl}/startup/traction`,
	checkTractionUpdate: `${baseUrl}/startup/traction-check`,

	
	getQuestions: `${baseUrl}/question/getQuestions`,
	googleLogin: `${baseUrl}/users/googleLogin`,
	googleRegister: `${baseUrl}/users/googleRegister`,
	Register: `${baseUrl}/users/createUser`,
	answerQuestion: `${baseUrl}/question/answerQuestion`,
	getQuestionCount: `${baseUrl}/question/getQuestionCount`,
	addRecentExperience: `${baseUrl}/users/addExperience`,
	addRecentEducation: `${baseUrl}/users/addEducation`,
	updateRecentEducation: `${baseUrl}/users/updateEducation`,
	deleteRecentEducation: `${baseUrl}/users/deleteEducation`,
	updateRecentExperience: `${baseUrl}/users/updateExperience`,
	deleteRecentExperience: `${baseUrl}/users/deleteExperience`,
	getLastMessage: `${baseUrl}/message/getLastMessage`,
	rejectMeetingRequest: `${baseUrl}/schedule/rejectMeetingRequest`,
	getUserAchievements: `${baseUrl}/achievement/getUserAchievements`,
	submitFundingToMail: `${baseUrl}/contactUs/lookingForFundingMail`,
	addNotificationAPI: `${baseUrl}/notification/addNotification`,
	getAllChats: `${baseUrl}/chat/getAllChats`,
	addPastInvestments: `${baseUrl}/investor/addPastInvestmentsController`,
	sendOtp: `${baseUrl}/users/send_otp`,
	verifyOtp: `${baseUrl}/users/verify_otp`,
	liveDeals: `${baseUrl}/live_deal/add_to_live_deals`,
	getLiveDeals: `${baseUrl}/live_deals/get_live_deals`,
	addInvestorToLiveDeal: `${baseUrl}/live_deals/add_investor_to_live_deal`,
	addArticle: `${baseUrl}/article/add_article`,
	subscription: `${baseUrl}/subscription/create_subscription`,
	verifySubscription: `${baseUrl}/subscription/verify_subscription`,
	getPaymentDetail: `${baseUrl}/subscription/get_subscription`,
	updateTopVoices: `${baseUrl}/users/updateTopVoice`,
	getInshortNews: `${baseUrl}/news/inshortsNews`,
	getMoreInshortNews: `${baseUrl}/news/inshortsNews/more`,
	reportPost: `${baseUrl}/users/report`,
	getEventsByOnelinkId: `${baseUrl}/meetings/getEventsByOnelinkId`,
	createEvent: `${baseUrl}/meetings/createEvent`,
	updateEvent: `${baseUrl}/meetings/updateEvent`,
	disableEvent: `${baseUrl}/meetings/disableEvent`,
	createWebinar: `${baseUrl}/webinars/createWebinar`,
	editWebinar: `${baseUrl}/webinars/editWebinar`,
	getAllWebinars: `${baseUrl}/webinars/getWebinars`,
	// /getWebinarsByCommunityId/:communityId
	getWebinarsByCommunityId: `${baseUrl}/webinars/getWebinarsByCommunityId`,
	getWebinarsByOnelinkId: `${baseUrl}/webinars/getWebinarsByOnelinkId`,
	deleteWebinar: `${baseUrl}/webinars/deleteWebinar`,
	createPaymentSessionToJoinWebinar: `${baseUrl}/webinars/createPaymentSession`,
	varifyPaymentToJoinWebinar: `${baseUrl}/webinars/verifyPayment`,
	getUserByUsername: `${baseUrl}/users/getUserByUsername`, ///getUserByUsername/:username
	createPaymentSessionForPriorityDM: `${baseUrl}/priorityDM/createPaymentSession`,
	varifyPaymentForPriorityDM: `${baseUrl}/priorityDM/verifyPayment`,
	getPriorityDMForUser: `${baseUrl}/priorityDM/getPriority-DMForUser`,
	getPriorityDMForFounder: `${baseUrl}/priorityDM/getPriority-DMForFounder`,
	updatePriorityDM: `${baseUrl}/priorityDM/updatePriority-DM`,
	getPriorityDMById: `${baseUrl}/priorityDM/getPriorityDMById`,
	sendOneLinkRequest: `${baseUrl}/startup/sendOneLinkRequest`,
	getOneLinkRequest: `${baseUrl}/startup/getOneLinkRequest`,
	approveOneLinkRequest: `${baseUrl}/startup/approveOneLinkRequest`,
	rejectOneLinkRequest: `${baseUrl}/startup/rejectOneLinkRequest`,
	getThoughts: `${baseUrl}/thoughts/get-questions`,
	// "/updateAnswerOfQuestion/:questionId/:answerId"
	// 	"/deleteAnswerOfQuestion/:questionId/:answerId",
	// "/update-question/:questionId"
	// "/delete-question/:questionId"

	updateAnswerOfQuestion: `${baseUrl}/thoughts/updateAnswerOfQuestion`,
	deleteAnswerOfQuestion: `${baseUrl}/thoughts/deleteAnswerOfQuestion`,
	updateQuestion: `${baseUrl}/thoughts/update-question`,
	deleteQuestion: `${baseUrl}/thoughts/delete-question`,
	// /getUserByUserNameOrOneLinkId/:username/:onelinkId
	getUserByUserNameOrOneLinkId: `${baseUrl}/users/getUserByUserNameOrOneLinkId`,
	// getUserByOneLinkId/:oneLinkId
	getUserByOneLinkId: `${baseUrl}/users/getUserByOneLinkId`,
	// "/getWebinarByWebinarId/:webinarId"
	getWebinarByWebinarId: `${baseUrl}/webinars/getWebinarByWebinarId`,
	// /updateWebinar/:id
	updateWebinar: `${baseUrl}/webinars/updateWebinar`,

	getAllStartUpsForJobs: `${baseUrl}/startup/getAllStartUpsForJobs`,
	createJobListing: `${baseUrl}/jobs/createJob`,
	getAllJobListings: `${baseUrl}/jobs/getAllJobs`,
	getJobListingById: `${baseUrl}/jobs/getJobById`,
	getMyJobListings: `${baseUrl}/jobs/getMyJobs`,
	// /getSavedJobs
	// /saveJob/:jobId
	getSavedJobs: `${baseUrl}/jobs/getSavedJobs`,
	saveJob: `${baseUrl}/jobs/saveJob`,
	addProductToCommunity: `${baseUrl}/communities/addProductToCommunity`,
	getProductByIdAPI: `${baseUrl}/communities/product`,
	buyProductFromCommunity: `${baseUrl}/communities/buyProduct`,
	deleteProductFromCommunity: `${baseUrl}/communities/deleteProductFromCommunity`,
	updateProductFromCommunity: `${baseUrl}/communities/updateProductOfCommunity`,

	// Community Service APIs - Priority DMs
	createPriorityDM: `${baseUrl}/communities/services/priorityDM`, // POST /:communityId
	updatePriorityDM: `${baseUrl}/communities/services/priorityDM`, // PATCH /:communityId/:dmId
	bookPriorityDM: `${baseUrl}/communities/services/priorityDM/book`, // POST /:communityId/:dmId
	deletePriorityDM: `${baseUrl}/communities/services/priorityDM`, // DELETE /:communityId/:dmId
	getPriorityDM: `${baseUrl}/communities/services/priorityDM`, // GET /:communityId/:dmId
	getAllPriorityDMs: `${baseUrl}/communities/services/priorityDM/all`, // GET /:communityId
	answerPriorityDMQuestion: `${baseUrl}/communities/services/priorityDM/answer`, // PATCH /:communityId/:dmId/:questionId/answer
	// Community Service APIs - Meetings
	createServiceMeeting: `${baseUrl}/communities/services/meeting`, // POST /:communityId
	updateServiceMeeting: `${baseUrl}/communities/services/meeting`, // PATCH /:communityId/:meetingId
	bookServiceMeeting: `${baseUrl}/communities/services/meeting/book`, // POST /:communityId/:meetingId
	bookServiceMeetingByBody: `${baseUrl}/communities/services/meeting/bookByBody`, // POST /:communityId/:meetingId/:userId
	deleteServiceMeeting: `${baseUrl}/communities/services/meeting`, // DELETE /:communityId/:meetingId
	getServiceMeeting: `${baseUrl}/communities/services/meeting`, // GET /:communityId/:meetingId
	getAllServiceMeetings: `${baseUrl}/communities/services/meeting/all`, // GET /:communityId
	getReleventUserMeetings: `${baseUrl}/communities/services/meeting/relevent`, // GET /:communityId/:userId
	updateServiceMeetingAvailability: `${baseUrl}/communities/services/meeting/availability`, // PATCH /:communityId/:meetingId
	createPaymentSession: `${baseUrl}/communities/create-payment-session`,
	verifyPayment: `${baseUrl}/communities/verify-payment`,

	// Toggle Recieve Email
	toggleRecieveEmail: `${baseUrl}/communities/toggleRecieveEmail`,

	//RAG APIs
	getAIAnswers: `${baseUrl}/investor/answeraiOnly`,
	getAIResults: `${baseUrl}/investor/getaiMatches`,

	// Campaign APIs
	getFilteredInvestorsList: `${baseUrl}/campaign/lists/getFilteredInvestorsList`,
	createFilteredInvestorsList: `${baseUrl}/campaign/lists/createFilteredInvestorsList`,
	updateFilteredInvestorsList: `${baseUrl}/campaign/lists/updateFilteredInvestorsList`,
	deleteFilteredInvestorsList: `${baseUrl}/campaign/lists/deleteFilteredInvestorsList`,
	getFilteredInvestorsListById: `${baseUrl}/campaign/lists/getFilteredInvestorsListById`,
	addInvestorToList: `${baseUrl}/campaign/lists/addInvestorToList`,
	removeInvestorFromList: `${baseUrl}/campaign/lists/removeInvestorFromList`,
	addVcToList: `${baseUrl}/campaign/lists/addVcToList`,
	removeVcFromList: `${baseUrl}/campaign/lists/removeVcFromList`,

	createTemplate: `${baseUrl}/campaign/templates/createTemplate`,
	getTemplates: `${baseUrl}/campaign/templates/getTemplates`,
	getTemplateById: `${baseUrl}/campaign/templates/getTemplateById`,
	updateTemplate: `${baseUrl}/campaign/templates/updateTemplate`,
	deleteTemplate: `${baseUrl}/campaign/templates/deleteTemplate`,

	createCampaign: `${baseUrl}/campaign/createCampaign`,
	getCampaigns: `${baseUrl}/campaign/getCampaigns`,
	getCampaign: `${baseUrl}/campaign/getCampaign`,
	updateCampaign: `${baseUrl}/campaign/updateCampaign`,
	deleteCampaign: `${baseUrl}/campaign/deleteCampaign`,
	scheduleCampaign: `${baseUrl}/campaign/scheduleCampaign`,
	runCampaign: `${baseUrl}/campaign/runCampaign`,

	// Payment APIs
	getAllPayments: `${baseUrl}/payment/getAllPayments`,
	getPaymentByUserEmailPhone: `${baseUrl}/payment/getPaymentByUserEmailPhone`,
	getPaymentByCommunityId: `${baseUrl}/payment/getPaymentByCommunityId`,

	// Startup Spotlight APIs
	addSpotlightProduct: `${baseUrl}/spotlight_products/addSpotlightProduct`,
	getSpotlightProducts: `${baseUrl}/spotlight_products/getSpotlightProducts`,
	// /getSpotllightProductById/:productId, /addSpotlightProductComment/:productId, /likeSpotlightProductComment/:commentId, /replySpotlightProductComment/:commentId
	getSpotlightProductById: `${baseUrl}/spotlight_products/getSpotlightProductById`,
	addSpotlightProductComment: `${baseUrl}/spotlight_products/addSpotlightProductComment`,
	likeSpotlightProductComment: `${baseUrl}/spotlight_products/likeSpotlightProductComment`,
	likeSpotlightProduct: `${baseUrl}/spotlight_products/likeSpotlightProduct`,
	replySpotlightProductComment: `${baseUrl}/spotlight_products/replySpotlightProductComment`,
	voteComment: `${baseUrl}/spotlight_products/voteComment`,
	downVoteComment: `${baseUrl}/spotlight_products/downVoteComment`,
	upvoteReply: `${baseUrl}/spotlight_products/upvoteReply`,
	downvoteReply: `${baseUrl}/spotlight_products/downvoteReply`,
	deleteStartupSpotlightProductComment: `${baseUrl}/spotlight_products/deleteComment`,
	deleteStartupSpotlightProductReply: `${baseUrl}/spotlight_products/deleteReply`,
	incrementShareCount: `${baseUrl}/spotlight_products/incrementShareCount`,
	// saveSpotlightProduct/:productId
	saveSpotlightProduct: `${baseUrl}/spotlight_products/saveSpotlightProduct`,
	getSpotlightProductRequests: `${baseUrl}/spotlight_products/getSpotlightProductRequests`,
	updateSpotlightProductRequestStatus: `${baseUrl}/spotlight_products/updateSpotlightProductRequestStatus`,
	updateSpotlightProductDuringApproval: `${baseUrl}/spotlight_products/updateSpotlightProductDuringApproval`,
	upvoteSpotlightProduct: `${baseUrl}/spotlight_products/upvoteProduct`,
	downvoteSpotlightProduct: `${baseUrl}/spotlight_products/downvoteProduct`,
	createEarlyGrowthProduct: `${baseUrl}/spotlight_products/createEarlyGrowthProduct`,
	getEarlyGrowthProducts: `${baseUrl}/spotlight_products/getEarlyGrowthProducts`,
	// Member Affiliation APIs (Startup)
	sendMemberAffiliationRequest: `${baseUrl}/startup/member-affiliation-request`,
	getMemberAffiliationRequests: `${baseUrl}/startup/member-affiliation-requests`,
	updateMemberAffiliationRequest: `${baseUrl}/startup/member-affiliation-request`,

	// Member Affiliation APIs (Investor)
	sendInvestorAffiliationRequest: `${baseUrl}/investor/member-affiliation-request`,
	getInvestorAffiliationRequests: `${baseUrl}/investor/member-affiliation-requests`,
	updateInvestorAffiliationRequest: `${baseUrl}/investor/member-affiliation-request`,

	getUsersOfInvestor: `${baseUrl}/investor/getUsersOfInvestor`,

	// User Activity Tracking APIs
	trackUserActivity: `${baseUrl}/user-activity/track`,
	getUserActivities: `${baseUrl}/user-activity/user`,
	getUserSessionActivities: `${baseUrl}/user-activity/session`,
	getUserActivityAnalytics: `${baseUrl}/user-activity/analytics`,

	// Home Page(New) APIs
	// /users/getExploreForPublic?type=vc
	// /users/getExploreForPublic?type=investor
	getInvestorsAndVcsList: `${baseUrl}/users/getExploreForPublic`,
});

export default API;
